import {Reference} from '../../reference';
import {AvailabilityMacroStatus} from '../availabilityMacroStatus';

export interface PlugType extends CodeLabel {
    '@type': 'PlugType';
    chargeMode?: string;
    iconRef?: string;
    orientation?: string;
}

export interface CodeLabel extends Reference {
    '@type': 'CodeLabel' | 'PlugType';
    label?: string;
}

export interface PlugTypeDto {
    availableOtp?: boolean;
    availableRemoteStart?: boolean;
    iconRef?: string;
    iconUrl?: string;
    maxPowerInW?: number;
    name?: string;
    status?: AvailabilityMacroStatus;
    userCableRequirement?: UserCableRequirement;
}

export enum UserCableRequirement {
    NONE = 'NONE',
    MAYBE = 'MAYBE',
    REQUIRED = 'REQUIRED',
}
